import {Injectable} from '@angular/core';
import {getLockIconConfig} from '@application/helper/get-lock-icon-config';
import {LastModifiedCardUtils} from '@application/helper/last-modified-card-utils';
import {NavigationId} from '@application/helper/routing/navigation-id.enum';
import {NavigationUtils} from '@application/helper/routing/navigation-utils';
import {HttpShiftsService} from '@infrastructure/http/calendar/shift/http-shifts.service';
import {GridColorPreviewCellRendererParams} from '@presentation/pages/textile-data/color/overview/grid-color-preview/grid-color-preview-cell-renderer-params';
import {GridColorPreviewComponent} from '@presentation/pages/textile-data/color/overview/grid-color-preview/grid-color-preview.component';
import {
  ColDefBuilderFactoryService,
  Color,
  ColorConstants,
  ContentSwitcherNavigationInput,
  convertHexadecimalColorCodeToRGB,
  CrudColdef,
  GridOptionsBuilder,
  NoDataOverlayComponentParams,
  OverlayComponentParams,
  StringUtils,
  TranslateService
} from '@vdw/angular-component-library';
import {ICellRendererParams} from 'ag-grid-community';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ShiftOverviewService {
  private readonly PAGE_URLS = LastModifiedCardUtils.getPageUrls('shift');

  public constructor(
    private readonly colDefBuilderFactoryService: ColDefBuilderFactoryService,
    private readonly shifts: HttpShiftsService,
    private readonly translate: TranslateService
  ) {}

  public getColumnDefs(enableClickableName: boolean = true, rowActionsComplete?: Subject<void>): CrudColdef {
    const editRoute = NavigationUtils.getNavigationRoute(NavigationId.EDIT_SHIFT);
    return {
      colDefs: [
        this.colDefBuilderFactoryService
          .getBuilder()
          .withHeaderName('GENERAL.NAME')
          .withColIdAndField('name', true)
          .withCellRenderer(
            GridColorPreviewComponent,
            (params: ICellRendererParams) =>
              ({
                color: new Color(null, params.data.name, convertHexadecimalColorCodeToRGB(ColorConstants[`${params.data.color}_500`]), false),
                editPageUrl: this.PAGE_URLS.edit,
                enableClickableName,
                rowActionsComplete,
                contentSwitcherEntry: {componentInfo: {component: editRoute.component}, data: editRoute.data} as ContentSwitcherNavigationInput,
                lockIconConfig: getLockIconConfig(params.data.name, this.shifts.getConflicts(params.data.id), rowActionsComplete)
              }) as GridColorPreviewCellRendererParams
          )
          .withComparator(StringUtils.stringComparator)
          .build()
      ],
      rowActionsComplete: null
    } as CrudColdef;
  }

  public getDefaultGridOptionsBuilder(builder: GridOptionsBuilder): GridOptionsBuilder {
    return builder
      .withLoadingOverlay({
        scale: 0.7
      } as OverlayComponentParams)
      .withNoRowsOverlay({
        scale: 0.7,
        titleParam: this.translate.instant('CALENDAR.SHIFT.SHIFT_CODE', {count: 1}),
        hideDescription: true
      } as NoDataOverlayComponentParams);
  }
}
